import { Box, CircularProgress, Typography } from "@mui/joy";
import { ServicesList } from "../servicesList/servicesList";
import { useGigs } from "../../redux/gig/gigHooks";

/**
 *
 * @returns {ReactElement} UpcomingServices page
 */
export function UpcomingServices() {
  const { gigs, isLoading } = useGigs();
  const upcoming = gigs.filter((g) => !g.completed());

  return (
    <Box sx={{ pt: 2 }}>
      <Typography
        sx={{ fontWeight: 700, fontSize: "1.25rem", letterSpacing: "-0.01em" }}
        endDecorator={
          isLoading ? (
            <CircularProgress size="sm" />
          ) : (
            <Typography
              sx={{
                fontSize: "0.8125rem",
                fontWeight: 600,
                px: 1,
                py: 0.125,
                borderRadius: "999px",
                color: "var(--mui-palette-primary-main)",
                background:
                  "rgba(var(--mui-palette-primary-mainChannel) / 0.1)",
              }}
            >
              {upcoming?.length}
            </Typography>
          )
        }
      >
        Upcoming Services
      </Typography>
      <Box
        sx={{
          pt: 1.5,
          pb: 2,
          width: "100%",
          display: "flex",
        }}
      >
        <ServicesList upcoming embedded tile />
      </Box>
    </Box>
  );
}
